/**
 * 查找spm缓存信息
 */
const handleDomSpmCache = (ctx: any, change: any) => {
  try {
    let target = change.target;
    let spmObj: any = {};
    const alreadyDatasetObj = ctx._domSpmCache.get(change.target);
    if (!alreadyDatasetObj) {
      while (target && target.dataset) {
        target.dataset.jtSpmb && (spmObj.pageDesc = target.dataset.jtSpmb);
        target.dataset.jtSpmc && (spmObj.blockDesc = target.dataset.jtSpmc);
        target.dataset.jtSpmd && (spmObj.buttonDesc = target.dataset.jtSpmd);
        // 向上冒泡
        target = target.parentNode;
      }
      ctx._domSpmCache.set(change.target, spmObj);
    } else {
      spmObj = alreadyDatasetObj;
    }
    const data = JSON.parse(change.target.dataset.jtBlockExposure || change.target.dataset.jtHideElementExposure);
    // 优先使用业务参数 data，其次 spmObj
    const newSpmObj = {
      page_desc: spmObj.pageDesc,
      block_desc: spmObj.blockDesc,
      button_desc: spmObj.buttonDesc,
    };
    return { ...newSpmObj, ...data };
  } catch {}
};
/**
 * 建立模块曝光观察者
 */
export const createBlockExposure = (ctx: any) => {
  try {
    ctx._blockExposureObserver = new IntersectionObserver(
      (changes) => {
        changes.forEach((change: any) => {
          if (change.intersectionRatio < 0.5) {
            return;
          }
          ctx.sendTracker(handleDomSpmCache(ctx, change));
        });
      },
      { threshold: 0.5 }
    );
  } catch {}
};

/**
 * 刷新模块曝光
 */
export function refreshBlockExposure(this: any) {
  try {
    if (!this._options.enableBlockExposure) {
      return;
    }
    // TODO: 是否有更好方法
    clearTimeout(this._blockExposureTimer); // 防抖
    this._blockExposureTimer = setTimeout(() => {
      this._blockExposureObserver.disconnect();
      const doms = document.querySelectorAll('[data-jt-block-exposure]');
      doms.forEach((item) => {
        this._blockExposureObserver.observe(item);
      });
    }, 500);
  } catch {}
}

/**
 * 建立隐藏元素曝光观察者
 */
export const createHideElementExposure = (ctx: any) => {
  try {
    ctx._hideElementExposureObserver = new IntersectionObserver((changes) => {
      changes.forEach((change: any) => {
        if (change.intersectionRatio <= 0) {
          return;
        }
        ctx.sendTracker(handleDomSpmCache(ctx, change));
      });
    });
  } catch {}
};

/**
 * 刷新隐藏元素曝光
 */
export function refreshHideElementExposure(this: any) {
  try {
    if (!this._options.enableHideElementExposure) {
      return;
    }
    clearTimeout(this._hideElementExposureTimer); // 防抖
    this._hideElementExposureTimer = setTimeout(() => {
      this._hideElementExposureObserver.disconnect();
      const doms = document.querySelectorAll('[data-jt-hide-element-exposure]');
      doms.forEach((item) => {
        this._hideElementExposureObserver.observe(item);
      });
    }, 200);
  } catch {}
}
